import ipadmainService from "../../../services/IpadPreview/ipadmain.service";
import ScheduleService from "../../../services/schedule.service";

const state = {
    selectedFlightItems: [],
    KeyForNetline : "",
    EFF_Json_Data : null,
    WR_Json_Data : null,
    AttachmentsJson :null,
    OCCSelfVersions_VS_IPADLastKnownVersions:[],
    ActiveDevice_UID : null,
    LastInputsJson : null,
    InputsObject : {BTO: {}, IF: {}, AL: {}},
    InputFiles : [],
    RawInputs : [],
    CombinedJson : [],
    OCCVers_IPADVers_LastIndex : null,
    NotamImportantList : [],
};

const getDefaultState = () => {
    return {
        EFF_Json_Data : null,
        WR_Json_Data : null,
        AttachmentsJson :null,
        OCCSelfVersions_VS_IPADLastKnownVersions:[],
        LastInputsJson : null,
        ActiveDevice_UID: null,
        InputsObject : {BTO: {}, IF: {}, AL: {}},
        InputFiles : [],
        RawInputs : [],
        CombinedJson : [],
        OCCVers_IPADVers_LastIndex : null,
        NotamImportantList : [],
    }
};

const mutations = {

    setSelectedFlightItems(state, payload)
    {
        state.selectedFlightItems = payload;
    },

    set_EFFjson_data(state,payload)
    {
        state.EFF_Json_Data = payload;
    },

    set_WR_json_data(state,payload)
    {
        state.WR_Json_Data = payload;
    },

    set_LastAttachmentJson_data(state,payload)
    {
      state.AttachmentsJson = payload;
    },

    set_OCCSelfVersions_VS_IPADLastKnownVersions(state,payload)
    {
        state.OCCSelfVersions_VS_IPADLastKnownVersions = payload;
    },

    set_OCCSelfVersions_VS_IPADLastKnownVersionsLastIndex(state,payload)
    {
        state.OCCVers_IPADVers_LastIndex = payload.length-1;
    },

    set_GetLastInputsJson(state,payload)
    {
        state.LastInputsJson = payload;
    },

    set_inputsToObject(state,payload)
    {
        state.InputsObject = payload;
    },

    set_RawInputsToObject(state,payload)
    {
        state.RawInputs = payload;
    },

    resetInputs (state)
    {
        Object.assign(state, getDefaultState())
    },

    set_InputFiles(state,payload)
    {
       state.InputFiles = payload;
    },

    set_CombinedJson(state,payload)
    {
      state.CombinedJson = payload;
    },

    set_NotamImportantList(state,payload)
    {
      state.NotamImportantList=payload;
    },

};

const actions = {

    async GetCombinedAllJson({commit},{KFZ,STD,JLVT,WLVT,DeviceUID})
    {

        var CombinedJson = await ipadmainService.GetCombinedJsons(KFZ,STD,JLVT,WLVT,DeviceUID);
        var combjs = CombinedJson.data;

        commit("set_EFFjson_data", combjs.jr);
        commit("set_WR_json_data", combjs.wr);
        commit("set_RawInputsToObject", combjs.inputs);
        commit("set_CombinedJson", CombinedJson);
        commit("set_InputFiles", combjs.inputf);

        return CombinedJson;
    },

    async GetLastAttachmentJson({commit},{LastKeyForNetline})
    {
        var GetLastAttachmentJson = await ipadmainService.GetLastAttachmentJsonserv(LastKeyForNetline)
        commit("set_LastAttachmentJson_data" ,GetLastAttachmentJson);
        return GetLastAttachmentJson;
    },

    async GetLastOCCSelfVersions_VS_IPADLastKnownVersions({commit},{KFZ})
    {
       var OccSelfVersionsVSIPADLastKnownVersions = await ipadmainService.GetApiLastOCCSelfVersions_VS_IPADLastKnownVersions(KFZ);
       commit("set_OCCSelfVersions_VS_IPADLastKnownVersions", OccSelfVersionsVSIPADLastKnownVersions);
       commit("set_OCCSelfVersions_VS_IPADLastKnownVersionsLastIndex", OccSelfVersionsVSIPADLastKnownVersions);
       return  OccSelfVersionsVSIPADLastKnownVersions;
    },

    async SetinputsToObject({commit},{data})
    {
        commit("set_inputsToObject", data);
    },

    async GetNotamImportantWList({commit})
    {
        var wordlist= await ScheduleService.GetNotamImportantList();

        commit("set_NotamImportantList", wordlist);
    },


    ClearInputsObject({commit})
    {
        commit('resetInputs');
    }

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
